module.exports = __webpack_public_path__ + "img/innoenergy_white.59e86514.png";